import { render, staticRenderFns } from "./DxWeatherTemperatureGrid.vue?vue&type=template&id=ddc375f4&"
import script from "./DxWeatherTemperatureGrid.vue?vue&type=script&lang=js&"
export * from "./DxWeatherTemperatureGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports